export default __webpack_public_path__ + "static/actions-en-48fd65216764d02e68381369e2e6beae.png";